export default "__VITE_ASSET__BEpmjN0E__"